import { Fragment, useState } from "react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { Modal, ModalBody, ModalFooter } from "reactstrap";

function ModalUpload({ onSubmit }) {
    const [minOrder, setMinOrder] = useState(0);
    const [minImpression, setminImpression] = useState(0);
    const [minView, setMinView] = useState(0);
    const [minClickRate, setMinClickRate] = useState(0);
    const [isOpen, setIsOpen] = useState(false);
    const { t } = useTranslation();

    const onChange = (e) => {
        if (e.target.name === "minOrder") {
            setMinOrder(e.target.value);
        }
        if (e.target.name === "minImpression") {
            setminImpression(e.target.value);
        }
        if (e.target.name === "minView") {
            setMinView(e.target.value);
        }
        if (e.target.name === "minClickRate") {
            setMinClickRate(e.target.value);
        }
    }

    const onClose = () => {
        setIsOpen(false);
    };

    const handleSubmit = () => {
        onSubmit({ minOrder, minImpression, minView, minClickRate });
        onClose();
    };

    return (
        <Fragment>
            <button
                className="btn btn-sm btn-primary"
                data-bs-toggle="modal"
                data-bs-target="#kt_modal_create_app"
                id="kt_toolbar_primary_button"
                onClick={() => setIsOpen(true)}
            >
                <i className="ki-outline ki-cloud-download"></i>
                {t("Data Optimize")}
            </button>
            <Modal
                centered={true}
                size="lg"
                toggle={() => {
                    onClose();
                }}
                isOpen={isOpen}
            >
                <div className="modal-header">
                    <h1 className="mb-0 text-dark">{t("Support for Optimize")}</h1>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal">
                        <i
                            className="ki-outline ki-cross fs-1"
                            onClick={() => {
                                onClose();
                            }}
                        ></i>
                    </div>
                </div>
                <ModalBody>
                    <div className="row mb-5">
                        <div className="col form-group">
                            <label>Min Order</label>
                            <div className="al-form-input-date">

                                <input type="number" className="form-control w-100" min={0} placeholder="0" name="minOrder" value={minOrder} onChange={(e) => {
                                    onChange(e);
                                }} />
                            </div>
                        </div>
                        <div className="col form-group">
                            <label>Min Impression</label>
                            <div className="al-form-input-date">

                                <input type="number" className="form-control w-100" min={0} placeholder="0" name="minImpression" value={minImpression} onChange={(e) => {
                                    onChange(e);
                                }} />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col form-group">
                            <label>Min View</label>
                            <div className="al-form-input-date">

                                <input type="number" className="form-control w-100" min={0} placeholder="0" name="minView" value={minView} onChange={(e) => {
                                    onChange(e);
                                }} />
                            </div>
                        </div>
                        <div className="col form-group">
                            <label>Min Click Rate</label>
                            <div className="al-form-input-date">

                                <input type="number" className="form-control w-100" min={0} placeholder="0" name="minClickRate" value={minClickRate} onChange={(e) => {
                                    onChange(e);
                                }} />
                            </div>
                        </div>
                    </div>

                </ModalBody>
                <ModalFooter>
                    <button
                        type="reset"
                        id="kt_modal_users_search_reset"
                        data-bs-dismiss="modal"
                        className="btn btn-active-light me-3"
                        onClick={() => {
                            onClose();
                        }}
                    >
                        {t("Cancel")}
                    </button>
                    <button
                        onClick={handleSubmit}
                        type="submit"
                        id="kt_modal_users_search_submit"
                        className="btn btn-primary"
                    >
                        {t("Save")}
                    </button>
                </ModalFooter>
            </Modal>
        </Fragment>
    );
}

const mapStateToProps = (state) => ({});
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(ModalUpload);
